import { render, staticRenderFns } from "./Tjhc.vue?vue&type=template&id=29d77f9a&scoped=true&"
import script from "./Tjhc.vue?vue&type=script&lang=js&"
export * from "./Tjhc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d77f9a",
  null
  
)

export default component.exports